<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    class="call-outs-search-form"
                    @submit.prevent="doSearch"
                >
                    <div class="row">
                        <div class="col-2">
                            <label class="label">Date from:</label>
                            <date-picker
                                v-model="search.start_date"
                                :options="{format: 'L'}"
                            />
                        </div>
                        <div class="col-2">
                            <label class="label">Date from:</label>
                            <date-picker
                                v-model="search.end_date"
                                :options="{format: 'L'}"
                            />
                        </div>
                        <div class="col-2">
                            <label class="label">Customer:</label>
                            <customer-search
                                ref="customerSearch"
                                @change="customerChanged"
                            />
                        </div>
                        <div class="col-3">
                            <button
                                class="btn btn-primary no-print"
                                style="margin-top: 2rem;"
                            >
                                <i class="fa fa-search" /> Search
                            </button>

                            <button
                                class="btn btn-info no-print"
                                style="margin-top: 2rem;"
                                @click.prevent="exportReport"
                            >
                                <i class="fas fa-download" /> Export
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="card">
            <div class="card-body text-center">
                <div class="stats">
                    <span class="stats__label">Average Attend Time:</span>
                    <span class="stats__val">{{ averageAttendTime }}</span>
                </div>

                <div class="stats">
                    <span class="stats__label">Days:</span>
                    <span class="stats__val">{{ daysDiff }}</span>
                </div>

                <div class="stats">
                    <span class="stats__label">Jobs Attended:</span>
                    <span class="stats__val">{{ attendedCount }}</span>
                </div>

                <div class="stats">
                    <span class="stats__label">Total Jobs:</span>
                    <span class="stats__val">{{ jobs.length }}</span>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Job Name</th>
                                    <th>Customer</th>
                                    <th>Site</th>
                                    <th>Start At</th>
                                    <th>Attended At</th>
                                    <th>Time to Attend (h:m)</th>
                                    <th>Target Time</th>
                                    <th>Attended By</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(job, index) in jobs"
                                    :key="index"
                                >
                                    <td>
                                        <router-link :to="{ name: 'office.jobs.show', params: { id: job.id } }">
                                            {{ job.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{ name:'office.customers.show', params: { id: job.customer.id } }">
                                            {{ job.customer.company_name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <span v-if="!job.site">-</span>
                                        <span v-if="job.site">{{ job.site.name }}</span>
                                    </td>
                                    <td>
                                        {{ startAt(job) }}
                                    </td>
                                    <td>
                                        {{ attendedAt(job) }}
                                    </td>
                                    <td>
                                        <span :class="timeToAttendClass(job)">{{ timeToAttend(job) }}</span>
                                    </td>
                                    <td>
                                        {{ targetTime(job) }}
                                    </td>
                                    <td>
                                        {{ attendedBy(job) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JobService from "../../../services/JobService";
import DatePicker from "../../DateTimePickerComponent";
import CustomerSearch from "../../CustomerSearch.vue";

const dateFormat = "DD/MM/YYYY HH:mm";
export default {
    components: {
        DatePicker,
        CustomerSearch
    },
    data() {
        return {
            search: {
                start_date: window.moment().subtract(1, "month").startOf('day'),
                end_date: window.moment().endOf('day'),
                is_call_out: true,
                customer_id: null
            },
            jobs: [],
            loading: false,
            daysDiff: '-',
        };
    },

    computed: {
        averageAttendTime() {
            let count = 0;
            let totalMins = 0;
            this.jobs.forEach(job => {
                if (job.attended_at == null) {
                    return;
                }

                const start = window.moment.utc(job.first_time_slot.start);
                const attend = window.moment.utc(job.attended_at);

                totalMins += start.diff(attend, "minutes");
                count++;
            });

            const average = (totalMins / count);

            return this.formatMins(average);
        },

        attendedCount() {
            return this.jobs.filter(job => job.attended_at != null).length;
        },
    },

    mounted() {
        this.doSearch();
    },

    methods: {
        doSearch() {
            this.loading = true;
            const params = {
                is_call_out: this.search.is_call_out,
                "filter[start_date]": this.search.start_date.format(
                    "YYYY-MM-DD"
                ),
                "filter[end_date]": this.search.end_date.clone().add(1, 'day').format("YYYY-MM-DD"),
                "filter[customer_id]": this.search.customer_id,
                include: ["customer", "site", "attendedBy", "firstTimeSlot"],
                all: 1
            };
            JobService.search(params).then(res => {
                this.jobs = res.data.data;
                this.loading = false;
                this.calculateDaysDiff();
            });
        },

        targetTime(job) {
            return job.customer.response_time_hours + ' hrs';
        },

        startAt(job) {
            return window.moment
                .utc(job.first_time_slot.start)
                .format(dateFormat);
        },

        attendedAt(job) {
            if (job.attended_at == null) {
                return "Not Attended";
            }

            return window.moment.utc(job.attended_at).format(dateFormat);
        },

        timeToAttend(job) {
            if (job.attended_at == null) {
                return "-";
            }

            const start = window.moment.utc(job.first_time_slot.start);
            const attend = window.moment.utc(job.attended_at);

            let totalMins = start.diff(attend, "minutes");

            return this.formatMins(totalMins);
        },

        timeToAttendClass(job) {
            if (job.attended_at == null) {
                return "";
            }

            const start = window.moment.utc(job.first_time_slot.start);
            const attend = window.moment.utc(job.attended_at);

            let hours = attend.diff(start, "hours");

            if (hours > job.customer.response_time_hours) {
                return 'over-target';
            }
            
            return 'on-target';
        },

        attendedBy(job) {
            if (job.attended_by == null) {
                return '-';
            }

            return job.attended_by.name;
        },

        customerChanged(customer) {
            if (!customer) {
                this.search.customer_id = null;
                return;
            }
            this.search.customer_id = customer.id;
        },

        formatMins(totalMins) {
            if(isNaN(totalMins)){
                return '-';
            }

            if (totalMins < 0) {
                totalMins = totalMins * -1;
            }

            const hours = Math.floor(totalMins / 60);

            const mins = totalMins % 60;

            return window._.padStart(Math.floor(hours), 2, '0') + ":" + window._.padStart(Math.floor(mins), 2, '0');
        },

        calculateDaysDiff() {
            if(!this.search.start_date || !this.search.end_date) {
                this.daysDiff = '-';
                return;
            }

            let diff =  this.search.start_date.startOf('day').diff(this.search.end_date.endOf('day'), 'days');

            if (diff < 0) {
                diff = diff * -1;
            }

            diff++;

            this.daysDiff = diff + ' days';
        },

        exportReport () {
            window.print();
        },
    }
};
</script>

<style lang="scss" scoped>
.on-target {
    color: #009900;
}
.over-target {
    color: #880000
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/jobs/CallOutJobsComponent.vue